<template>
    <div>
      <q-dialog ref="modal" :maximized="true" v-model="modal" @hide="$_limpaDadosBusca">
        <q-card>
          <q-toolbar class="bg-primary">
            <q-toolbar-title><span class="text-body1 text-white">Buscar produtos</span></q-toolbar-title>
            <q-btn flat round dense color="white" icon="close" v-close-popup />
          </q-toolbar>
  
          <q-lins-filter-box :expanded="expand" @update="expand = !expand" :aplicarBusca="buscarProduto"
            :limpar="$_limpaDadosBusca">
            <template v-slot:filtros>
              <div class="q-gutter-x-sm justify-center" :class="$q.screen.xs ? 'q-gutter-y-sm' : 'row'">
                <q-input
                  v-model="filtros.descricao_produto"
                  :disable="filtros.cod_familia != null || filtros.cod_marca  != null"
                  @keyup= "()  => { filtros.descricao_produto = filtros.descricao_produto.toUpperCase()}"
                  placeholder="Ex.: Camiseta Adidas"
                  @keyup.enter="buscarProduto"
                  class="col q-pl-sm"
                  label="Descrição"
                  square
                />
                <q-select
                  :disable="filtros.descricao_produto != null"
                  v-model="filtros.cod_familia"
                  @keyup.enter="buscarProduto"
                  :options="opcoes_filtro_familia"
                  label="Codigo Familia"
                  @filter="$_filterSelectFamilia"
                  input-debounce="0"
                  class="col q-pl-sm"
                  use-input
                  square
                />
                <q-select
                  :disable="filtros.descricao_produto != null"
                  v-model="filtros.cod_marca"
                  @keyup.enter="buscarProduto"
                  :options="opcoes_filtro_marcas"
                  @filter="$_filterSelectMarca"
                  input-debounce="0"
                  label="Codigo Marca"
                  class="col q-pl-sm"
                  use-input
                  square
                />
              </div>
            </template>
          </q-lins-filter-box>
          <q-card-section class="no-margin q-pa-xs">
          </q-card-section>
  
          <q-card-section class="no-margin q-pa-xs">
            <q-card class="shadow-2 q-pa-xs" v-if="lista_produtos.length != 0">
              <q-lins-table
                id="tabProdutos"
                ref="tabProdutos"
                :data-table="lista_produtos"
                :auto-load="false"
                :columns="columns"
                :expand="true"
                :pagination="false"
                :on-cell-click="$_buscarCodPai"
              >
              <template v-slot:expand="props">
                <div :class="$q.screen.sm ? 'q-gutter-y-sm' : 'row'">
                  <div class="col-2 justify-center text-center q-ma-xs">
                    <section v-if="props.row.urls_imagens[0]">
                      <q-imagem 
                        :altImg="props.row.urls_imagens[0].seq_img"
                        :url="props.row.urls_imagens[0].url_img"
                        :styleImg="'height: 140px; max-width: 140px;'"
                        :classeImg="'q-mt-md q-mr-sm'"
                      />
                      <q-btn class="full-width q-ma-sm" icon="image" color="primary" @click="() => abrirModalFoto(props.row.urls_imagens)">ver fotos</q-btn>
                    </section>
                    <q-img src="../assets/no-image.png" v-else style="height: 200px; max-width: 200px" class="q-mt-md q-mr-sm"/>
                  </div>
                  <div class="col">
                    <q-lins-table
                      :id="`tabConsultaExpandTam${props.row.id}`"
                      :ref="`tabConsultaExpandTam${props.row.id}`"
                      :data-table="props.row.variacoes"
                      :auto-load="false"
                      :columns="columnsVariacao"
                      :pagination="false"
                      :show-copy-button="true"
                      :copy-field="'cod_produto'"
                      :copy-message="'Copiar codigo do produto'"
                  />
                  </div>
                </div>
              </template>
              </q-lins-table>
            </q-card>
            <q-visualizador-foto ref="modalFotos" />
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </template>
  <script>
  import Router from '@/router/index.js'
  import store from '@/store/index.js'
  import { ref } from 'vue'
  import QLinsTable from '@/shared/QLinsDrfTable.vue'
  import QLinsFilterBox from '@/shared/QlinsFilterBox.vue';
  import QVisualizadorFoto from './QVisualizadorFoto.vue';
  import MixinMessages from '@/mixins/mixinMessagens';
  import FamiliaServices from '@/services/familias';
  import MarcasServices from '@/services/marcas';
  import ConsultaProdutoServices from '@/services/produtos';
  import QImagem from './QImagem.vue';
  import { useStore } from 'vuex';
  
  let opcao_familia = []
  let opcao_marca = []
  export default {
    name: "QModalBuscaProdutos",
    components: { QLinsTable, QLinsFilterBox, QVisualizadorFoto, QImagem },
    mixins: [MixinMessages],
    emits: ['buscaCodPai'],
  
    setup() {
      const store = useStore()
      const expand = ref(true)
      const lista_produtos = ref([])
      const filtros = ref({
        descricao_produto: null,
        cod_familia: null,
        doc_marca: null,
      })
      const columns = ref([
        {
          name: "cod_pai_senior",
          field: 'cod_pai_senior',
          label: "Codigo Senior",
          align: "left",
          width: "20ch"
        },
        {
          name: "desc_familia",
          field: 'desc_familia',
          label: "Familia"
        },
        {
          name: "marca",
          field: 'marca',
          label: "Marca"
        },
        {
          name: "descricao",
          field: 'descricao',
          label: "Descricao"
        },
      ])

      const columnsVariacao = ref([
        {
          name: "Variacões",
          field: 'descricao',
          label: "Variacões",
          align: "start",
          width: "100%"
        },
        {
          name: "cod_prod",
          field: 'cod_produto',
          label: "Codigo Produto",
          width: "40ch",
        }
      ])
      const opcoes_filtro_marcas= ref([])
      const opcoes_filtro_familia= ref([])
  
      return {
        opcao_familia,
        opcao_marca,
        columnsVariacao,
        columns,
        filtros,
        store,
        expand,
        lista_produtos,
        opcoes_filtro_familia,
        opcoes_filtro_marcas
      }
    },
    methods: {
      show() {
        this.buscarFamiliaSenior()
        this.buscarMarcasSenior()
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      buscarProduto() {
        this.lista_produtos = []
        const params = {}
        this.$_showLoading({ message: "Buscando produtos..." })
        if (!this.filtros.descricao_produto && !this.filtros.cod_familia && !this.filtros.cod_marca) {
          this.errorMessage({
            title: "Erro",
            message: "Por favor informe uma descrição ou selecione marca e familia"
          })
          this.$_hideLoading()
        } else {
            if (this.filtros.descricao_produto) {
              params.desc_produto_generico = this.filtros.descricao_produto
            }
            if (this.filtros.cod_familia) {
              params.cod_familia = this.filtros.cod_familia.value
            }
            if (this.filtros.cod_marca) {
              params.cod_marca = this.filtros.cod_marca.value
            }
          params.group_by = 'cod_pai_senior'
          ConsultaProdutoServices.buscarProdutos(params)
            .then(async res => {
              this.$_hideLoading()
              this.formataDadosTabela(res)
            })
            .catch( error => {
              this.$_hideLoading()
              this.errorMessage({title: "Erro ao consultar API", message:"Não foi possivel consultar api"})
              console.log(error)
            })
        }
      },
      formataDadosTabela(dados) {
        this.$_showLoading({ message: "Buscando estoques do produto" })
        if(dados.produtos.length > 0){
          dados.produtos.map(produto=>{
            if(produto.variacoes.length == 1){
              produto.descricao = produto.desc_produto
            } else {
              produto.descricao = produto.desc_produto_nf
            }
            this.lista_produtos.push(produto)
            this.expand = false
          })
        }else {
          this.warningMessage({title: "Atenção", message:"Não foi encontrado produtos para esta pesquisa. Verifique os parametros de busca."})
        }
        this.$_hideLoading()
      },
      buscarMarcasSenior(){
        this.$_showLoading({ message: "Carregando filtro de marcas.." })
        opcao_marca = []
        MarcasServices.get({ cod_rede: this.store.getters.getCodigoRede }).then(res=>{
          res.marcas.map(opt => opcao_marca.push({value: opt.cod_marca, label: `${opt.cod_marca} ${opt.desc_marca}`}))
          this.$_hideLoading()
        }).catch(error => {

          if (error.response.data.code == "token_not_valid"){
                this.errorMessage({
                    title: "Erro",
                    message: "Sessão expirada! Faça o login novamente!"
                })

                store.commit('logout')
                store.commit('limpaEstabelecimentos')
                Router.push('/login')

                localStorage.setItem("jwtToken", "")
                localStorage.setItem("recaptchaToken", "")
            }
          else{
            this.warningMessage({title: "Atenção", message:"Não foi possivel carregar os dados de marca senior. Por favor atualize a pagina."})
          }
          this.$_hideLoading()
        })
      },
      buscarFamiliaSenior(){
        this.$_showLoading({ message: "Carregando filtro de familias.." })
        FamiliaServices.get({ cod_rede: this.store.getters.getCodigoRede }).then(res=>{
          opcao_familia = []
          res.familias.map(opt => opcao_familia.push({value: opt.cod_familia, label: `${opt.cod_familia} ${opt.desc_familia}`}))
          this.$_hideLoading()
        }).catch(error => {
          this.warningMessage({title: "Atenção", message:"Selecione o estabelecimento na tela inicial!"})
          console.log(error)
          this.$_hideLoading()
        })
      },
      pushUnique(item, array) {
        if (!array.some(el => el.value == item.value)) {
          array.push(item)
        }
      },
      limpaDados() {
        this.filtros.descricao_produto = null
        this.filtros.cod_familia = null
        this.filtros.cod_marca = null
      },

      $_filterSelectFamilia(val, update){
        if (val.length === '') {
          this.opcoes_filtro_familia = opcao_familia
          return
        }

        update(() => {
          const needle = val.toLowerCase()
          this.opcoes_filtro_familia = opcao_familia.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
        })
      },

      $_filterSelectMarca(val, update){
        if (val.length === '') {
          this.opcoes_filtro_marcas = opcao_marca
          return
        }

        update(() => {
          const needle = val.toLowerCase()
          this.opcoes_filtro_marcas = opcao_marca.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
        })
      },
      
      $_buscarCodPai(row){
        this.limpaDados()
        this.$emit('buscaCodPai', row.cod_pai_senior)
      },

      $_limpaDadosBusca(){
        this.limpaDados()
        this.lista_produtos = []
        this.expand = true
      },

      abrirModalFoto(fotos) {
        this.$refs.modalFotos.show(fotos)
      },

      $_showLoading(options) {
        this.$q.loading.show(options)
      },
  
      $_hideLoading() {
        this.$q.loading.hide()
      }
    },
  }
  </script>